import React, { useState } from 'react'
import './style.scss'
import { Link } from 'react-router-dom'

import Menu from '../../components/Menu'
import Footer from '../../components/Footer'
import MedalLink from '../../components/MedalsEbit-Link'
import { Form, InputGroup, Button, Col } from '../../../node_modules/react-bootstrap'




function ReactivationStore() {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };


  return (
    <>
      <Menu></Menu>


      <section className="container">

        <div className="reactivate-store">
          <h2>Reativar minha loja</h2>
          <p className="lead">Para reativar sua loja, nos envio o formulário abaixo preenchido corretamente que em breve entraremos em contato.</p>


          <div className="reactivate-store__form-reactivate">


            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group as={Col} md="4" controlId="validationCustom01">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Nome"
                  // defaultValue="Mark"
                  />
                  <Form.Control.Feedback>Ok!</Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid">
                      Digite o nome.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="validationCustom02">
                  <Form.Label>Nome da Loja</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Nome da Loja"
                  // defaultValue="Otto"
                  />
                  <Form.Control.Feedback>OK!</Form.Control.Feedback>
                  <Form.Control.Feedback type="invalid">
                      Digite o nome da loja.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="validationCustomUsername">
                  <Form.Label>E-mail</Form.Label>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      type="email"
                      placeholder="E-mail"
                      aria-describedby="inputGroupPrepend"
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Digite um e-mail válido.
                    </Form.Control.Feedback>
                    <Form.Control.Feedback>Ok!</Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} md="4" controlId="validationCustom03">
                  <Form.Label>Ebit ID</Form.Label>
                  <Form.Control type="number" placeholder="Ebit ID" required />
                  <Form.Control.Feedback type="invalid">
                    Digite o Ebit-Id de sua loja.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="validationCustom04">
                  <Form.Label>CNPJ</Form.Label>
                  <Form.Control type="number" placeholder="CNPJ" required />
                  <Form.Control.Feedback type="invalid">
                    Digite o CNPJ de sua loja.
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
              <Button className="btn-form-reactivate-store" type="submit"><b>Enviar</b></Button>
              
            </Form>
          </div>

          <h2>Saiba o motivo da loja estar inativa</h2>

          <p className="lead">A loja é inativada quando não compartilha dados com a Ebit | Nielsen há mais de 90 dias e, portanto, foi descadastrada da nossa base de dados.</p>

        </div>

      </section>


      {/* <MedalLink /> */}


      <Footer></Footer>
    </>
  );
}

export default ReactivationStore;